var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('header',[_c('page-title',[_vm._v("Home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }